import { toast } from 'react-toastify'
import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { learningApi } from '../../../services/api'
import { RootState } from '../rootReducer'
import { fetchCourses } from './action'
import { LearningCoursesTypes } from './types'

function* load() {
  try {
    const { token, status } = yield select((state: RootState) => ({
      token: state.auth.token,
      status: state.learningCourses.status,
    }))

    if (!token) return
    if (status !== 'idle') return

    yield put(fetchCourses.request())

    const responseCourse = yield call(learningApi.get, '/course', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    const responseCombo = yield call(learningApi.get, '/combo', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (!responseCourse || !responseCombo) {
      const error = { response: { data: 'Network Error' } }
      throw error
    }

    const { message: messageCourse } = responseCourse.data
    const { message: messageCombo } = responseCombo.data

    const response = [...responseCourse.data, ...responseCombo.data]

    yield put(fetchCourses.success({ data: messageCourse && messageCombo ? [] : response }))
  } catch (error) {
    if (error?.response && error?.response?.status !== 404 && error?.response?.status !== 401) {
      toast.error('Não foi possível carregar seus cursos. tente novamente mais tarde.')
    }

    yield put(fetchCourses.failure({ error: error.response }))
  }
}

export default all([takeEvery(LearningCoursesTypes.GET_LEARNING_COURSES_ONCE, load)])
